import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { ACTIONS, SCREENS } from '../../constants/Tracking';
import { AppContext, appActions } from '../../contexts/app/context';
import { CommentsPropsContext } from '../../contexts/comments/PropsContext';
import { CommentsContext } from '../../contexts/comments/context';
import HoverActions from '../common/HoverActions/HoverActions';
import CommentRichTextEditor from './CommentRichTextEditor';
import CommentRowButtons from './CommentRowButtons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CommentListRow({
  content,
  onSaveComment,
  onDeleteComment
}) {
  const {
    hubspotUserId,
    usageTracker,
    openUrl
  } = useContext(CommentsPropsContext);
  const {
    owners
  } = useContext(CommentsContext);
  const {
    appName
  } = useContext(AppContext);
  const [isEditMode, setEditMode] = useState(false);
  const [isCommentCreator, setIsCommentCreator] = useState(true);
  const [linkElements, setLinkElements] = useState([]);
  const cardRef = useRef(null);
  const commentOwner = useMemo(() => owners.find(owner => Number(owner.userId) === content.userId), [content.userId, owners]);
  const onEditComment = () => {
    usageTracker.trackInteraction(Object.assign({
      screen: SCREENS.comments
    }, ACTIONS.comments.edit));
    setEditMode(true);
    appActions.setSkipIntervalRefresh(true);
  };
  const onSave = newComment => {
    onSaveComment(content.commentId)(newComment);
    setEditMode(false);
    appActions.setSkipIntervalRefresh(false);
  };
  const onCancel = () => {
    setEditMode(false);
    appActions.setSkipIntervalRefresh(false);
  };
  const linkClickHandler = useCallback(e => {
    e.preventDefault();
    openUrl(e.target.href);
  }, [openUrl]);
  useEffect(() => {
    setIsCommentCreator(content.userId === hubspotUserId);
  }, [content, hubspotUserId]);

  // add event listeners to links elements
  useEffect(() => {
    linkElements.forEach(link => {
      link.addEventListener('click', linkClickHandler);
    });
    return () => {
      linkElements.forEach(link => {
        link.removeEventListener('click', linkClickHandler);
      });
    };
  }, [linkClickHandler, linkElements]);

  // set link elements
  useEffect(() => {
    if (cardRef.current && !isEditMode) {
      setLinkElements(Array.from(cardRef.current.querySelectorAll('a[href]')));
    }
    if (isEditMode) {
      setLinkElements([]);
    }
  }, [isEditMode, content.message]);
  return /*#__PURE__*/_jsx(CardWrapper, {
    compact: true,
    "data-test-id": `${appName}-comments-card`,
    children: isEditMode ? /*#__PURE__*/_jsx(CommentRichTextEditor, {
      dataTestId: `${appName}-comments-editor-edit-mode`,
      onSave: onSave,
      initialValue: content.message,
      onCancel: onCancel
    }) : /*#__PURE__*/_jsx(HoverActions, {
      Buttons: CommentRowButtons,
      buttonsProps: {
        onEditComment,
        onDeleteComment,
        isCommentCreator
      },
      appName: appName,
      children: /*#__PURE__*/_jsx(CardSection, {
        scrollable: true,
        paddingInline: "600",
        paddingBlock: "400",
        children: /*#__PURE__*/_jsx(ExpandableText, {
          maxHeight: 250,
          children: /*#__PURE__*/_jsxs("div", {
            ref: cardRef,
            children: [/*#__PURE__*/_jsxs(TFlex, {
              direction: "column",
              children: [commentOwner ? /*#__PURE__*/_jsx(Text, {
                as: "strong",
                children: /*#__PURE__*/_jsx(TruncateString, {
                  useFlex: true,
                  maxWidth: 200,
                  children: commentOwner.text
                })
              }) : null, /*#__PURE__*/_jsx(Text, {
                color: "text-core-default",
                marginBlockStart: "100",
                children: I18n.moment(content.createdAt).fromNow()
              })]
            }), /*#__PURE__*/_jsx(Box, {
              marginBlockStart: "200",
              children: /*#__PURE__*/_jsx(SanitizedText, {
                body: content.message,
                textSeleniumKey: `${appName}-comments-card-value`
              })
            })]
          })
        })
      })
    })
  });
}
export default CommentListRow;